import {IAccount} from "./account.model";
import {ICurrency} from "./devise.model";

export interface ICashRegister {
  id?: string;
  institutionId: string;
  institutionName?: string;
  name: string;
  code: string;
  mainCurrency: ICurrency;
  type: CashRegisterType;
  minBalance?: number;
  maxBalance?: number;
  status: CashRegisterStatus;
  linkedAccount?: IAccount;
}

export enum CashRegisterType {
  MAIN = "Principal",
  SECONDARY = "Secondaire",
  PETTY_CASH = "Petite caisse",
  EXCHANGE = "Change"
}

export enum CashRegisterStatus {
  ACTIVE = "Active",
  CLOSED = "Fermée",
  MAINTENANCE = "Maintenance"
}

export interface ICashSession {
  id?: string;
  cashRegister: ICashRegister;
  cashierId: string;
  sessionDate: Date;
  openedAt: Date;
  closedAt?: Date;
  openingBalance: number;
  expectedBalance?: number;
  actualBalance?: number;
  variance?: number;
  status: SessionStatus;
}

export enum SessionStatus {
  OPEN = "Ouverte",
  CLOSED = "Fermée",
  RECONCILED = "Rapprochée"
}

export interface ICashTransaction {
  id?: string;
  cashSessionId: string;
  type: CashTransactionType;
  libelle: string;
  description?: string;
  amount: number;
  operationDate: Date;
  valueDate: Date;
  currency: ICurrency;
  reference?: string;
  customerName?: string;
  customerAccount?: string;
  linkedVirementId?: string;
  linkedAccountId?: string;
  comments?: string;
  denominations?: ICashDenomination[];
  status: TransactionStatus;
}

export enum CashTransactionType {
  DEPOSIT = "Versement",
  WITHDRAWAL = "Retrait",
  TRANSFER_IN = "Réception transfert",
  TRANSFER_OUT = "Envoi transfert",
  ADJUSTMENT = "Ajustement"
}

export enum TransactionStatus {
  PENDING = "En attente",
  VALIDATED = "Validée",
  CANCELLED = "Annulée"
}

export interface ICashDenomination {
  id?: string;
  value: number;
  quantity: number;
  totalAmount: number;
  currency: ICurrency;
}
